<template>
  <v-card border elevation="1" flat height="280" rounded="lg" width="300">
    <v-card-text class="search">
      <v-text-field
        v-model="search"
        color="white"
        density="compact"
        hide-details
        placeholder="Пошук за ПІБ..."
        prepend-inner-icon="mdi-magnify" />
    </v-card-text>

    <v-list class="bg-white" density="compact">
      <v-list-item
        v-for="item in filteredItems"
        :key="item.id"
        color="blue-grey-lighten-5"
        @click="selectItem(item)">
        <template #prepend>
          <div class="d-flex align-center ga-2">
            <v-checkbox-btn
              v-if="multiple"
              :model-value="isSelected(item.id)"
              color="blue-darken-3" />
            <v-avatar :color="getAvatarColor(item.name)" size="30">
              {{ getInitials(item.name) }}
            </v-avatar>
          </div>
        </template>

        <v-list-item-title class="font-size-13 font-weight-bold">
          {{ item.name }}
        </v-list-item-title>

        <v-list-item-subtitle class="font-size-11">
          {{ item.departments?.[0]?.name || 'Департамент відсутній' }}
        </v-list-item-subtitle>
      </v-list-item>

      <v-list-item v-if="!filteredItems.length">
        <v-list-item-title class="text-grey">
          Нічого не знайдено
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script lang="ts">
import { computed, ref } from 'vue'
import { getDirectory } from '@/directory'

export default {
  name: 'TaskEmployeeSelect',
  props: {
    modelValue: { type: [Number, String, Array, null], default: null },
    multiple: { type: Boolean, default: false },
  },
  emits: ['update:modelValue', 'select'],
  setup(props, { emit }) {
    const search = ref('')

    const selectedIds = computed(() => {
      if (props.multiple) {
        return Array.isArray(props.modelValue) ? props.modelValue : []
      }

      return props.modelValue ? [props.modelValue] : []
    })

    const allUsers = computed(() => {
      return getDirectory('userList')
    })

    const filteredItems = computed(() => {
      if (!search.value) return allUsers.value
      return allUsers.value.filter(item =>
        item.name.toLowerCase().includes(search.value.toLowerCase())
      )
    })

    const isSelected = (id: any) => selectedIds.value.includes(id)

    const selectItem = (item: any) => {
      if (props.multiple) {
        const ids = isSelected(item.id)
          ? selectedIds.value.filter(id => id !== item.id)
          : [...selectedIds.value, item.id]

        emit('update:modelValue', ids)
      } else {
        emit('update:modelValue', item.id)
      }

      emit('select', item)
    }

    const getInitials = (name: any) =>
      name
        .split(' ')
        .map((part: any) => part[0])
        .join('')
        .slice(0, 2)
        .toUpperCase()

    const getAvatarColor = (name: any) => {
      const colors = [
        'blue-lighten-4',
        'green-lighten-4',
        'orange-lighten-4',
        'deep-purple-lighten-4',
        'indigo-lighten-4',
        'teal-lighten-4',
        'cyan-lighten-4',
        'lime-lighten-5',
        'amber-lighten-5',
        'brown-lighten-5',
      ]
      return colors[name.length % colors.length]
    }

    return {
      filteredItems,
      getAvatarColor,
      getInitials,
      isSelected,
      search,
      selectItem,
    }
  },
}
</script>

<style lang="scss" scoped>
.search {
  padding: 10px 12px;
  border-bottom: 1px solid #f0f0f5;
  background: #fafbfc;
}

:deep(.v-selection-control__wrapper) {
  width: 28px !important;
}
</style>
